'use es6';

import * as Operator from 'customer-data-filters/filterQueryFormat/operator/Operator';
import { KOALA, TRANSPARENT_LIGHT } from 'HubStyleTokens/colors';
import FilterOperatorType from 'customer-data-filters/components/propTypes/FilterOperatorType';
import FormattedMessage from 'I18n/components/FormattedMessage';
import MissingField from 'customer-data-filters/filterQueryFormat/MissingField';
import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import UIButton from 'UIComponents/button/UIButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIIconButton from 'UIComponents/button/UIIconButton';
import UITag from 'UIComponents/tag/UITag';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import classNames from 'classnames';
import styled from 'styled-components';
import DeprecatedFilter from '../../filterQueryFormat/operator/DeprecatedFilter';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HoverContent = styled.div.withConfig({
  displayName: "FilterEditorOperator__HoverContent",
  componentId: "ahxfy5-0"
})(["position:absolute;top:0;padding-left:24px;right:0;height:100%;background-image:linear-gradient( to left,", ",", ",", " );"], KOALA, KOALA, TRANSPARENT_LIGHT);
const HoverRow = styled.div.withConfig({
  displayName: "FilterEditorOperator__HoverRow",
  componentId: "ahxfy5-1"
})(["position:relative;cursor:pointer;overflow:hidden;&:focus,&:hover{background-color:", ";}"], KOALA);
class FilterEditorOperator extends PureComponent {
  constructor() {
    super();
    this.handleMouseEnter = () => {
      this.setState({
        isHoverContentVisible: true
      });
    };
    this.handleMouseLeave = () => {
      this.setState({
        isHoverContentVisible: false
      });
    };
    this.handleMouseMove = () => {
      // See https://git.hubteam.com/HubSpot/UIComponents/issues/3927
      if (this.state.isHoverContentVisible !== true) {
        this.setState({
          isHoverContentVisible: true
        });
      }
    };
    this.state = {
      isHoverContentVisible: false
    };
  }
  render() {
    const {
      children,
      className,
      hoverContentClassName,
      isReadOnly,
      isXoEnabled,
      onEdit,
      onRemove,
      operator
    } = this.props;
    const {
      isHoverContentVisible
    } = this.state;
    const isMissingField = MissingField.isMissingField(operator.field);
    const isRestrictedAsset = operator.field.userHasNoAccess;
    const isEditable = !isReadOnly && !isMissingField;
    const onClick = isEditable && !isReadOnly ? onEdit : undefined;
    const HoverRowComponent = isReadOnly ? 'div' : HoverRow;
    const okayToBeMissingField = operator.constructor === DeprecatedFilter;
    return /*#__PURE__*/_jsx(UITooltip, {
      disabled: !isMissingField || okayToBeMissingField || isRestrictedAsset,
      placement: "right",
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `customerDataFilters.FilterEditorOperator.${isReadOnly ? 'missingFieldTooltipReadOnly' : 'missingFieldTooltip'}`
      }),
      children: isXoEnabled ? /*#__PURE__*/_jsxs(HoverRowComponent, {
        className: classNames('flex-grow-1 display-block m-x-0 p-all-0', className),
        "data-selenium-info": `${operator.field.name}`,
        "data-selenium-test": "FilterEditorOperator-xofilters",
        onClick: onClick,
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseLeave,
        onMouseMove: this.handleMouseMove,
        children: [children, !isReadOnly && isHoverContentVisible && /*#__PURE__*/_jsx(HoverContent, {
          className: hoverContentClassName,
          children: /*#__PURE__*/_jsx(UIIconButton, {
            onClick: evt => {
              evt.stopPropagation();
              onRemove(evt);
            },
            placement: "right",
            size: "small",
            tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "customerDataFilters.FilterEditorOperator.deleteTooltip"
            }),
            use: "transparent",
            children: /*#__PURE__*/_jsx(UIIcon, {
              name: "delete"
            })
          })
        })]
      }) : /*#__PURE__*/_jsx(UITag, {
        className: classNames('display-block m-x-0 m-bottom-3 p-y-1', className),
        closeable: !isReadOnly,
        "data-selenium-test": "FilterEditorOperator-filters2",
        multiline: true,
        onCloseClick: onRemove,
        use: !Operator.isValidOperator(operator) ? 'error' : 'default',
        children: /*#__PURE__*/_jsx(UIButton, {
          className: "p-all-1",
          disabled: !isEditable,
          onClick: onClick,
          use: "link",
          children: children
        })
      })
    });
  }
}
FilterEditorOperator.defaultProps = {
  isReadOnly: false
};
FilterEditorOperator.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  hoverContentClassName: PropTypes.string,
  isReadOnly: PropTypes.bool.isRequired,
  isXoEnabled: PropTypes.bool,
  onEdit: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  operator: FilterOperatorType.isRequired
};
export default FilterEditorOperator;